export default "__VITE_ASSET__BwJI_o2v__"